import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Trash2, UserCheck } from 'lucide-react';
import { Assistant, Laterality } from '@/lib/templates/types';

export function buildAssistantNoteText(
  assistant: Assistant | null,
  laterality: Laterality | null,
  procedureName: string
): string {
  const name = assistant?.assistant_name || 'Surgical Assistant';
  const creds = assistant?.credentials ? `, ${assistant.credentials}` : '';
  const lat = laterality
    ? laterality.charAt(0).toUpperCase() + laterality.slice(1)
    : '';

  return `Assistant Surgeon: ${name}${creds}. Medical necessity is indicated for a surgical assistant with a complex ${lat} ${procedureName}.

NOTE: The surgical assistant was utilized and essential to the procedure for positioning extremity, retraction, assisting with instrumentation and holding position of extremity so the surgeon had two hands free for placing implants and dissection. The surgical assistant was also utilized for incisional closure.`;
}

interface AssistantNoteBlockProps {
  onDelete: () => void;
  assistant?: Assistant | null;
  laterality?: Laterality | null;
  procedureName?: string;
}

export function AssistantNoteBlock({
  onDelete,
  assistant,
  laterality,
  procedureName = '',
}: AssistantNoteBlockProps) {
  const noteText = buildAssistantNoteText(assistant || null, laterality || null, procedureName);

  return (
    <Card className="border border-dashed border-primary/30 bg-primary/5">
      <CardContent className="p-3 space-y-1.5">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-1.5 text-xs font-semibold uppercase tracking-wider text-primary">
            <UserCheck className="w-3.5 h-3.5" />
            Assistant
          </div>
          <Button
            variant="ghost"
            size="sm"
            className="h-6 text-xs text-destructive hover:text-destructive hover:bg-destructive/10"
            onClick={onDelete}
          >
            <Trash2 className="w-3.5 h-3.5 mr-1" />
            Delete
          </Button>
        </div>
        <p className="text-xs text-muted-foreground leading-relaxed whitespace-pre-line">
          {noteText}
        </p>
      </CardContent>
    </Card>
  );
}
